<template>
  <div class="add-cell" @click="click">
    <div class="cell-title">{{ cellTitle }}</div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    cellTitle: {},
  },
  methods: {
    click() {
      this.$emit("click")
    }
  }
};
</script>

<style scoped lang="scss">
/deep/.el-form-item__label {
  color: #333;
}
.add-cell {
  padding: 0 0 24px 0;
  margin-left: 26px;
  min-height: 100px;
  .cell-title {
    line-height: 1;
    padding-bottom: 15px;
    font-size: 14px;
    color: #000000;
    font-weight: 500;
    &::before {
        content: "";
        width: 4px;
        height: 14px;
        display: inline-block;
        margin-right: 8px;
        background: #1F6EEF;
        transform: translateY(2px);
    }
  }
}
</style>